import { Component, OnInit, Input, AfterViewInit, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ApiHandlerService } from '../../../core/api-handlers';
import { untilDestroyed } from '../../../core/services';
import { HttpErrorResponse } from '@angular/common/http';
import { Logger } from '../../../core/logger/logger.service';
import { AppGlobal } from '../../../app.global';
import { Observable } from 'rxjs';
import { UtilityService } from '../../../core/services/utility.service';
import { AuthService } from '../../../modules/auth/auth.service';
import { NavigationStart, Router, NavigationEnd } from '@angular/router';
import { HomeService } from '../../../modules/home/home.service';
import { FlightService } from '../../../modules/flights/flight.service';
import { SocialAuthService } from 'angularx-social-login';
import { SubSink } from 'subsink';
import { SwalService } from '../../../core/services/swal.service';
import { environment } from 'projects/b2c/src/environments/environment';

declare var $: any;
const log = new Logger('shared/HeaderComponent');
const baseUrl = environment.baseUrl;
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('slider', { static: true }) slider: ElementRef;
    @Input('fromHomePage') headerFromHome = false;
    @Input('fromOtherPage') fromOtherPage = false;
    currencyData: Array<{}> = [];
    notificationData: Array<{}> = [];
    unreadCount: number;
    countryList: Array<{}> = [];
    selectedCurrency: string = '';
    loginDetails: any;
    currencyList: any;
    selectedCurrencyValue: string = 'USD';
    showCurrencyConversion: boolean = false;
    browserRefresh: boolean;
    currencyImage: string = ''
    currencyDropImage: string = ''
    domainData: any;
    cartItems: any;
    isCartEmpty: boolean = true;
    cartList: any;
    cartItemCount: number = 0;
    private subs = new SubSink();
    show: boolean = false;
    showCall: boolean = false;
    isMobileMenuOpen = false;
    isMobileMenuOpen1 = false;
    isMobileMenuOpen2 = false;
    isMobileMenuOpen3 = false;
    isMobileMenuOpen4 = false;
    isMobileMenuOpen5 = false;
    isMobileCallHeader: boolean = false;

    constructor(
        private apiHandlerService: ApiHandlerService,
        public globals: AppGlobal,
        private utilityService: UtilityService,
        private authenticationService: AuthService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private homeService: HomeService,
        private flightService: FlightService,
        private socialAuthService: SocialAuthService,
        private swalService: SwalService

    ) { }

    ngOnInit(): void {
        //     this.cartItemCount = count;
        //   });


        // this.cartService.cartList$.subscribe(cartList => {
        //     this.cartList = cartList;
        //     this.cartItemCount = this.cartList.length; // Update the count
        //   });

        // Listen to routing events
        //   this.router.events.subscribe(event => {
        //     if (event instanceof NavigationEnd) {

        //     this.cartItemCount = this.cartService.getCartList().length;// Recalculate cart count
        //     }
        //   });

        // this.listCart();
        this.checkBrowserRefresh();
        this.globals.showCurrencyConversion.next(true);
        this.authenticationService.currentUserSubject.subscribe(user => {
            this.loginDetails = JSON.parse(sessionStorage.getItem('b2cUser'));
            this.cdr.detectChanges()
        })
        this.globals.showCurrencyConversion.subscribe(c => {
            this.showCurrencyConversion = c;
            this.cdr.detectChanges()
        })

        this.globals.selectedCurrency.subscribe(c => {
            this.selectedCurrencyValue = c;
            this.currencyImage = `assets/images/country_flag/usd.png`;
            this.cdr.detectChanges();
        })


        this.getDomainLogo();
        this.manageDomain();
        this.getCurrencyList();
        this.getCountryList();
        this.getCurrencySymbols();


        getNotifications.subscribe(resp => {
            if (resp['statusCode'] == 200) {
                this.notificationData = resp['data'];
                this.unreadCount = resp['unreadCount'];
            }

        }, (err: any) => {
            log.debug(err.error);
            this.notificationData = [];
        });
    }


    toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }
    toggleMobileMenu1() {
        this.isMobileMenuOpen1 = !this.isMobileMenuOpen1;
    }
    toggleMobileMenu2() {
        this.isMobileMenuOpen2 = !this.isMobileMenuOpen2;
    }
    toggleMobileMenu3() {
        this.isMobileMenuOpen3 = !this.isMobileMenuOpen3;
    }
    toggleMobileMenu4() {
        this.isMobileMenuOpen4 = !this.isMobileMenuOpen4;
    }
    toggleMobileMenu5() {
        this.isMobileMenuOpen5 = !this.isMobileMenuOpen5;
    }
    closeMobileMenu() {
        this.isMobileMenuOpen = false;
    }
    closeMobileSideMenu() {
        this.isMobileMenuOpen1 = false;
        this.isMobileMenuOpen2 = false;
        this.isMobileMenuOpen3 = false;
        this.isMobileMenuOpen4 = false;
    }
    openCallModal() {
        this.isMobileCallHeader = true;
    }

    closeCallModal() {
        this.isMobileCallHeader = false;
    }
    showServices(event) {

    }

    checkBrowserRefresh() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.browserRefresh = !this.router.navigated;
                let selectedCurrency = JSON.parse(sessionStorage.getItem('selectedCurrency'));
                if (this.browserRefresh && selectedCurrency != null) {
                    this.selectedCurrencyValue = selectedCurrency;
                    this.globals.selectedCurrency.next(`${this.selectedCurrencyValue}`);
                }
            }
        });

    }

    listCart(): void {
        const req = {
            ResultToken: this.cartItems ? this.cartItems.ResultIndex : ''
        };
        this.subs.sink = this.apiHandlerService
            .apiHandler('getBundleBooking', 'POST', '', '', req)
            .subscribe(
                (res: any) => {
                    if (res && res.data) {
                        this.isCartEmpty = false;
                        this.cartList = res.data;
                        this.updateCartItemCount();
                    }
                },
                (error) => {
                    console.error('Error getting item of cart:', error);
                    this.isCartEmpty = true;
                    this.cdr.detectChanges();
                }
            );
    }


    updateCartItemCount(): void {
        let count = 0;
        if (this.cartList.flight) count++;
        if (this.cartList.hotel) count++;
        if (this.cartList.transfer) count++;
        if (this.cartList.activity) count++;
        this.cartItemCount = count;
    }


    currencyChanged(c: string) {
        this.globals.currentCurrency.next(`${c['symbol']} ${c['code']}`);
    }

    onSelectModule(moduleName: string) {
        if (moduleName == 'Flights') {
            this.router.navigate(["/flight"]);
        }
        else if (moduleName == 'Hotels') {
            this.router.navigate(["/hotels"]);
        }
        // if (this.router.url !== "/") {
        //     this.router.navigate([""]);
        //   }
        this.homeService.headerSearchTab.next(moduleName);
        this.homeService.precedence.next(moduleName);
        this.flightService.formFilled = false;
        return;
    }

    getCountryList() {
        getCountry.subscribe(resp => {
            if (resp['statusCode'] == 200) {
                this.countryList = resp['data'];
            }

        }, (err: any) => {
            log.debug(err.error);
            this.countryList = [];
        })
    }

    getDomainLogo() {
        this.apiHandlerService.apiHandler('domainLogo', 'post', {}, {}, { type: 'header' })
            .pipe(untilDestroyed(this))
            .subscribe(resp => {
                if (resp.Status && resp.Data) {
                    this.globals.logoHeader = String(resp.Data.domain_logo);
                }
            }, (err: HttpErrorResponse) => {

            })
    }
    manageDomain() {
        this.apiHandlerService.apiHandler('adminManageDomain', 'post', {}, {}, { type: 'header' })
            .pipe(untilDestroyed(this))
            .subscribe(resp => {

                if (resp.Status && resp.data) {
                    this.domainData = resp.data[0];

                }
            }, (err: HttpErrorResponse) => {

            })
    }
    getCurrencySymbols() {
        this.apiHandlerService.apiHandler('getCurrencySymbols', 'post', {}, {}, {})
            .pipe(untilDestroyed(this))
            .subscribe(resp => {
                if (resp.Status && resp.data) {
                    this.currencyData = resp['data'];
                    this.globals.currentCurrency.subscribe(c => {
                        this.selectedCurrency = c;
                    })
                }
            }, (err: HttpErrorResponse) => {

            })
    }
    onSupplier() {
        //this.hideHeaderFooter
        this.router.navigate(['/supplier/general/register_supplier']);
    }

    getCurrencyList() {
        this.apiHandlerService.apiHandler('currencyConverison', 'post', {}, {}, {})
            .pipe(untilDestroyed(this))
            .subscribe(resp => {
                if (resp.Status && resp.data) {
                    this.currencyList = resp.data.filter(t => t.status == 1);
                    if (this.currencyList.length === 0) {
                        this.countryList = undefined;
                    }
                }
            }, (err: HttpErrorResponse) => {

            })
    }

    setSelectedCurrency(c: string) {
        if (this.cartItemCount === 0) {
            this.changeCurrency(c);
        } else {
            // Show confirmation popup
            this.swalService.alert.oops("Empty the cart to change the currency");
        }
    }

    // Separate function for changing currency
    changeCurrency(c: string) {
        sessionStorage.setItem('selectedCurrency', JSON.stringify(c['currency']));
        this.globals.selectedCurrency.next(`${c['currency']}`);

        this.globals.selectedCurrency.subscribe(currency => {
            this.selectedCurrencyValue = currency;

            // Find the selected currency from the currency list
            const selectedCurrencyObj = this.currencyList.find(item => item.currency === currency);

            // If found, use the flag image from the object, else use a default placeholder
            this.currencyImage = selectedCurrencyObj
                ? this.getImage(selectedCurrencyObj.flag)
                : `assets/images/country_flag/usd.png`;
        });

        let currentUrl = this.router.url;
        if (currentUrl !== "/") {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate([currentUrl]);
        }
    }

    getImage(img) {
        if (img != null) {
            return `${baseUrl + '/sa/common/getImage/' + img}`;
        } else {
            return ""
        }
    }

    myfunction() {
        let y = $(document).scrollTop(); // window.document.documentElement.scrollTop;
        let navWrap = $('.wpb_wrapper_form_head').offset().top;
        if (y > 300 && navWrap > 300) {
            $('.wpb_wrapper_form_head').addClass('showsearch');
            $('.cstm_nav1 .qodefmenu').addClass('menualign');
            $('#search_box_head').focus(function () {
                $('.showsearch .show_data_list_head').show();
                $(document).bind('focusin.show_data_list_head click.show_data_list_head', function (e) {
                    if ($(e.target).closest('.show_data_list_head, #search_box_head').length) return;
                    $(document).unbind('.show_data_list_head');
                    $('.showsearch .show_data_list_head').hide();
                    $('.backdrop1').hide();
                });
                $('.backdrop1').show();
            });
        } else {
            $('.wpb_wrapper_form_head').removeClass('showsearch');
            $('.cstm_nav1 .qodefmenu').removeClass('menualign');
            $('.backdrop1').hide();
            $('.show_data_list_head').hide();
        }

    }

    setTheme(themeName) {
        localStorage.setItem('theme', themeName);
        document.documentElement.className = themeName;
    }
    toggleTheme() {
        if (localStorage.getItem('theme') === 'theme-dark') {
            this.setTheme('theme-light');
        } else {
            this.setTheme('theme-dark');
        }
    }

    getTheme() {
        if (localStorage.getItem('theme') === 'theme-light') {
            this.setTheme('theme-light');
            const ele = document.getElementById("slider") as HTMLInputElement;
            ele.checked = false;
        } else if (localStorage.getItem('theme') === 'theme-dark') {
            this.setTheme('theme-dark');
            const ele = document.getElementById("slider") as HTMLInputElement;
            ele.checked = true;
        }
    }


    ngAfterViewInit(): void {

        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        $(function () {
            $('.currency_selector').hover(function () {
                $('.currency_selector .dropdown-menu').addClass('show');
            },
                function () {
                    $('.currency_selector .dropdown-menu').removeClass('show');
                });
        });

        $(function () {
            $('.language-selector').hover(function () {
                $('.language-selector .dropdown-menu').addClass('show');
            },
                function () {
                    $('.language-selector .dropdown-menu').removeClass('show');
                });
        });


        $(function () {
            $('.currency_selector1').hover(function () {
                $('.currency_selector1 .dropdown-menu').addClass('show');
            },
                function () {
                    $('.currency_selector1 .dropdown-menu').removeClass('show');
                });
        });

        $(function () {
            $('.language-selector1').hover(function () {
                $('.language-selector1 .dropdown-menu').addClass('show');
            },
                function () {
                    $('.language-selector1 .dropdown-menu').removeClass('show');
                });
        });
    }

    logOut() {
        this.socialAuthService.signOut();
        this.utilityService.logout();
    }
    gotoB2bLogin() {
        this.router.navigate(["https://booking247.com/booking247/b2b/"])

    }
    redirrectToHome() {
        setTimeout(() => {
            window.scroll(0, 0);
        }, 1000);
        this.router.navigate(['/']);
        this.homeService.headerSearchTab.next('');
        // this.homeService.precedence.next('Flights');
        this.flightService.formFilled = false;
        return;

    }


    redirrectToCart() {
        this.router.navigate(["cart/bookings"]);
    }
    //  getImage(img){
    //     return `assets/images/country_flag/${img.toLocaleLowerCase()}.png`;
    // }

    ngOnDestroy(): void { }

}


let getData = new Observable((observer: any) => {
    try {
        observer.next(Data),
            observer.complete()

    } catch (error) {
        observer.error(error)
    }
});

let getNotifications = new Observable((observer: any) => {
    try {
        observer.next(nData),
            observer.complete()

    } catch (error) {
        observer.error(error)
    }
});

let getCountry = new Observable((observer: any) => {
    try {
        observer.next(country);
        observer.complete('I have no more country');
    } catch (error) {
        observer.error(error);
    }
})

let nData = {
    statusCode: 200,
    msg: '',
    unreadCount: 3,
    data: [
        {
            text: 'Ask real travellers questions or share your own tips about the United States.',
            photo: 'http://www.latimes.com/includes/projects/hollywood/portraits/keanu_reeves.jpg'
        },
        {
            text: 'Ask real travellers questions or share your own tips about the United States.',
            photo: 'http://www.latimes.com/includes/projects/hollywood/portraits/keanu_reeves.jpg'
        },
        {
            text: 'Ask real travellers questions or share your own tips about the United States.',
            photo: 'http://www.latimes.com/includes/projects/hollywood/portraits/keanu_reeves.jpg'
        },
        {
            text: 'Ask real travellers questions or share your own tips about the United States.',
            photo: 'http://www.latimes.com/includes/projects/hollywood/portraits/keanu_reeves.jpg'
        },
    ]
}

let Data = {
    statusCode: 200,
    msg: '',
    data: [
        {
            name: '',
            code: 'USD',
            symbol: '$'
        },
        {
            name: '',
            code: 'AED',
            symbol: 'د.إ',
        },
        {
            name: '',
            code: 'AUD',
            symbol: '$'
        },
        {
            name: '',
            code: 'SAR',
            symbol: '﷼'
        },
        {
            name: '',
            code: 'RUB',
            symbol: '₽'
        },
        {
            name: '',
            code: 'JPY',
            symbol: '¥'
        },
        {
            name: '',
            code: 'EUR',
            symbol: '€'
        },
        {
            name: '',
            code: 'INR',
            symbol: '₹'
        }
    ]
}


let country = {
    statusCode: 200,
    msg: '',
    data: [
        {
            language: 'English',
            flag_url: 'assets/images/flag-uk.png'
        },
        {
            language: 'French',
            flag_url: 'assets/images/flag-fr.png'
        },
        {
            language: 'Spanish',
            flag_url: 'assets/images/flag-es.png'
        },
    ]

}
